export default __webpack_public_path__ + "assets/ankiconnectInstall.946b2a7b.png";